import React from "react";
import MovimientoBase, { MovimientoBaseConfig } from "./MovimientoBase";

const config: MovimientoBaseConfig = {
  documentTitle: "Stock - Ajustes positivos | Saas",
  breadcrumbTitle: "Ajustes positivos",
  breadcrumbSection: "Stock",
  conceptoTitulo: "Ajuste positivo",
  conceptoValor: "Ajuste positivo",
  mostrarSeccionPersona: false,
  motivoOpciones: [
    { value: "donacion", label: "Donación / ingreso externo" },
    { value: "regularizacion", label: "Regularización" },
    { value: "ajuste_manual", label: "Ajuste manual" },
  ],
  motivoTipo: "ajuste_positivo",
  apiPath: "/api/stock/ajustes/positivos",
};

const AjustesPositivosPage: React.FC = () => <MovimientoBase config={config} />;

export default AjustesPositivosPage;
